Em.Handlebars.helper 'loyaltyProgramText', (info, kind) ->
  currentInfo = info.find (item)=> item.name == kind
  currentInfo.locales[Em.I18n.locale]